//EXTERNAL
import React from "react"
//COMPONENTS
import BouncingIcon from "../../BouncingIcon"
//ASSETS
// import demoArticleHero from "../../../assets/demo-article-hero.jpg";
import "../Article.css"
import "./DigitalTrendsArticle.css"
//FUNCTIONS

export default function DigitalTrendsArticleMobile(format) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "flex-column",
        justifyContent: "center",
        minWidth: "320px"
      }}>
      <div
        style={{
          backgroundColor: "white",
          overflowX: "hidden",
          overflowY: "scroll"
        }}>
        {/* <img
          src={demoArticleHero}
          style={{ width: "100%" }}
          alt="article-header"
        /> */}
        <div className="serif" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className="article-content">
            <h2 className="digital-trends-title f5 tl mh3 mb1">5 reasons to use Android 11’s quick access smart home controls</h2>
            <h4 className="digital-trends-author f7 mv1 mh3">By John Velasco</h4>
            <h4 className="f7 mv1 mh3">October 17, 2020</h4>
            <hr className="mh3" />
            <BouncingIcon />
            <div className="digital-trends-article-body">
              <p className="digital-trends-date mt1 mh2 f6">
                The smart home is always evolving, so while it may seem like there’s a level of complexity with gadgets communicating with each other and various services, Android 11 is here to simplify things. Now that Android 11 has rolled out to various Pixel devices, we’re getting more of an intimate look at how we’re able to access our connected devices in the home. We’ve already seen how Apple has tweaked its HomeKit smart home controls with the rollout of iOS 14, so now it’s Google’s
                turn. Simplification to a connected home, that’s the most notable aspect of this latest experience on Android — so here are five reasons to use Android 11’s new smart home controls.
              </p>
              <p className="digital-trends-article-subheader mh2">Quick controls with a long press</p>
              <p className="mt1 mh2 f6">
                Previously, performing commands or accessing controls were achieved by either asking Google Assistant or running the Home app. With Android 11, however, it’s been simplified substantially to provide us with instant controls by just long pressing the power button. All of your selected smart home gadgets are then populated in this new interface, which can then be controlled. From turning on the lights in the living room, to running your robot vacuum for a cleaning, these quick
                access controls make it simple and easy to do.
              </p>
              <div className="ad-creative flex flex-row justify-center">{format}</div>
              <p className="digital-trends-article-subheader mh2">Security before actions</p>
              <p className="mt3 mh2 f6">
                As we mentioned previously, the quick access controls can be launched at any time by pressing the power button — including while on the lock screen. Thankfully there’s still an added layer of security in place that prevents anyone who picks up your phone from interacting with your connected devices. Even though the quick access menu pops up while the phone is locked, it still requires you to bypass the lock screen with your password/authentication method. Meaning, even if you
                lose or misplace your phone, a stranger can’t mess around with the lights at your home without unlocking it first.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
